import React from "react";

export default function PlaySceneButton({playing=false}) {
    return <svg data-name="play-scene-btn">
        <polygon className="cls-16" points="244 102.85 25.24 118.17 0 0 224.02 12.04 244 102.85"/>
        <text filter="drop-shadow(0px 7px 0px black)" className="cls-23" transform="translate(31.77 94.25) scale(0.75 1)">{playing ? 'STOP' : 'PLAY'}</text>
    </svg>;
}
